// @flow
import React, { useState } from 'react';
import Slider from 'react-slick';
import { ImageGalleryItem } from 'components/atoms/imageGalleryItem';
import { ImageGalleryItemMobile } from 'components/atoms/imageGalleryItemMobile';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import type { GalleryImageType } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  activeImage: GalleryImageType,
  images: Array<GalleryImageType>,
};

export const ImageOverlay = (props: Props) => {
  const { activeImage, images } = props;
  const activeIndex = images.findIndex(image => image.id === activeImage.id);
  const [activeSlide, setActiveSlide] = useState(activeIndex);
  const [slider, setSlider] = useState();
  const { height, isMobile } = useViewport();

  const settings = {
    className: 'slider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: false,
    verticalSwiping: false,
    swipeToSlide: true,
    touchThreshold: 3000,
    beforeChange: (current, next) => setActiveSlide(next),
    initialSlide: activeIndex,
  };

  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  return (
    <div className={'image-overlay'}>
      <Slider ref={c => setSlider(c)} {...settings} style={{ height: '100%' }}>
        {images.map((item: GalleryImageType) => {
          return isMobile ? (
            <ImageGalleryItemMobile
              imageUrl={item.mediumMobileImageUrl}
              className={'image-overlay-item'}
              caption={item.caption}
              key={item.id}
            />
          ) : (
            <ImageGalleryItem
              imageUrl={item.mediumImageUrl}
              thumbNail={item.thumbnailMediumImageUrl}
              onClick={() => {}}
              className={'image-overlay-item'}
              caption={item.caption}
              key={item.id}
              isHoveredImagePresent={true}
            />
          );
        })}
      </Slider>
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          currentIndex={activeSlide + 1}
          total={images.length}
          onNextClick={next}
          onPreviousClick={previous}
        />
      </div>
    </div>
  );
};
